import { render, staticRenderFns } from "./org-freezer-week.vue?vue&type=template&id=b69f5d36&scoped=true&"
import script from "./org-freezer-week.vue?vue&type=script&lang=js&"
export * from "./org-freezer-week.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b69f5d36",
  null
  
)

export default component.exports